import { createPortal } from "react-dom";
import { useEffect } from "react";
import "./YoutubeVideoLightbox.css";

/**
 * Centered lightbox with an embeddable YouTube player (user presses play in the iframe).
 */
export default function YoutubeVideoLightbox({ open, onClose, videoId, title = "Video" }) {
  const id = String(videoId || "").trim();

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (typeof document === "undefined" || !open || !id) return null;

  const embedSrc = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0`;

  return createPortal(
    <div className="yt-video-lightbox" role="presentation" onClick={onClose}>
      <div
        className="yt-video-lightbox__frame"
        role="presentation"
        onClick={(event) => event.stopPropagation()}
      >
        <div
          className="yt-video-lightbox__dialog"
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          <button
            type="button"
            className="yt-video-lightbox__close"
            onClick={onClose}
            aria-label="Close video"
          >
            ×
          </button>
          <div className="yt-video-lightbox__player">
            <iframe
              src={embedSrc}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
